import createSvgIcon from "./utils/create_icon"

const Reset = createSvgIcon(<path d="M3 12a1 1 0 1 0 2 0V9a1 1 0 0 1 1-1h10.586l-1.293 1.293a1 1 0 0 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414l-3-3a1 1 0 1 0-1.414 1.414L16.586 6H6a3 3 0 0 0-3 3v3Zm18 0a1 1 0 1 0-2 0v3a1 1 0 0 1-1 1H7.414l1.293-1.293a1 1 0 1 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L7.414 18H18a3 3 0 0 0 3-3v-3Z" fill="currentColor" />, "Reset")
export default Reset
